var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-wrap"},[_c('el-container',{staticStyle:{"height":"100%"}},[_c('el-header',{staticStyle:{"height":"auto","padding":"0"}},[_c('Head')],1),_vm._v(" "),_c('el-main',[_c('router-view')],1),_vm._v(" "),_c('el-footer',[_c('Footer')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efb384e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/officalweb/index.vue
// module id = null
// module chunks = 